/* eslint-disable */
export default {
  unknown: 'Tuntematon',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
